import { Button } from "components/ui/button"
import { Loader2 } from "lucide-react"
import type { ConfirmationModalProps } from "../../types/components"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog"

export const SpecialConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading
}: ConfirmationModalProps) => (
  <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
    <AlertDialogContent
      className="max-w-lg z-[60]"
      onEscapeKeyDown={(e) => e.stopPropagation()}
    >
      <AlertDialogHeader>
        <AlertDialogTitle className="text-lg font-semibold text-[#4B303C]">
          Confirmar Reprovação Especial
        </AlertDialogTitle>
      </AlertDialogHeader>

      <div className="space-y-4">
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-800 font-medium mb-2">
            Atenção: Itens com Status Especial Detectados
          </p>
          <p className="text-xs text-red-700">
            Alguns dos itens selecionados têm status "Aguardando Nova Resposta".
            Estes itens já foram rejeitados anteriormente e estão aguardando nova resposta da loja.
          </p>
        </div>

        <p className="text-sm text-gray-600">
          Tem certeza que deseja reprovar novamente <strong>{selectedCount}</strong> item(s) selecionado(s)?
        </p>
      </div>

      <AlertDialogFooter>
        <Button
          variant="outline"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          variant="destructive"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
          ) : null}
          {isLoading ? "Processando..." : "Confirmar Reprovação"}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
